import api from 'api';
import makeSorter from 'lib/makeSorter';
import { regexpSearch } from 'lib/searchFns';
import ___ from '../constants';
import { forEach, result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';

const dateColumns = [
    'est_arrival_date',
];

const initialState = {
    currentEditRow: null,
    currentEditHeader: null,
    originalEditRow: null,
    detailLines: null,
    PROheaders: [],
    lastSelectedDocNum: null,   // IMPORTANT since we cant use react-router-dom useParams in redux, we have to store and pass this around
    lastViewMode: 'pro',        // IMPORTANT  ^ 
    originalOrders: [],
    filteredOrders: [],
    failedDocEntries: [],
    errors: [],
    loading: false,
    sendingTo: false,
    loadingDetails: false,
    searchLoading: false,
    columns: [],
    filteredSource: [],
    searchedSource: [],
    sortOrder: false,
    sortField: false,
    sorting: [],
    filters: [],
    requestedPage: 0,
    warehouseOptions: [],
    filterValues: {
        order_date_formatted: null,
        event_date: null,
        status: null,
    },
};

export const types = {
    SET_STATE: 'PRODUCTION/SET_STATE',
    SET_SEARCH_VALUE: 'PRODUCTION/SET_SEARCH_VALUE',
    SET_SORT: 'PRODUCTION/SET_SORT',
    UPDATE_ORDER: 'PRODUCTION/UPDATE_ORDER'
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            return { ...state, ...action.data };

        case types.SET_SEARCH_VALUE:
            return {
                ...state,
                searchValue: action.data,
            };

        case types.SET_SORT:
            return {
                ...state,
                sortField: action.data.field,
                sortOrder: action.data.order,
            };

        default:
            return state;
    }
};


export const selectHeaders = state =>
    state.warehouseProd.PROheaders;


export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    setSearchValue: (value) => ({
        type: types.SET_SEARCH_VALUE,
        data: value,
    }),

    setSort: (value) => ({
        type: types.SET_SORT,
        data: value,
    }),

    setCurrentEditRow: (row) => async (dispatch, getState) => {
        // console.log('[Production.redux.js] setCurrentEditRow');
        // console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getProductionOrderHeaders: () => async (dispatch, getState) => {
        console.log('[Production.redux.js] getProductionOrderHeaders()');
        const state = getState();
        dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Warehouse.GetProductionOrders
            let result = await api.get('/warehouse/production');
            //console.log(result)
            let _result = result.productionOrders.recordset;

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value)
            }
            console.log(_arrayResult)

            dispatch(actions.setState({
                PROheaders: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('[Production.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                PROheaders: [],
                loading: false
            }));
        }
    },

    getProductionOrders: (docNum, searchType) => async (dispatch, getState) => {
        console.log('[Production.redux.js] getProductionOrders()');
        console.log('docNum', docNum)
        console.log('searchType', searchType);

        const state = getState().warehouseProd;
        let { lastSelectedDocNum, lastViewMode } = state;
        let _docNum = docNum ?? lastSelectedDocNum;

        dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Warehouse.GetProductionOrderLines
            let result = await api.get(`/warehouse/production/${_docNum}`,
                {
                    params: {
                        docNum: _docNum,
                        searchType: searchType
                    },
                }
            );
            //console.log(result.productionOrders.recordset)
            let _result = result.productionOrders.recordset;

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value)
            }

            dispatch(actions.setState({
                lastSelectedDocNum: _docNum,
                originalOrders: _arrayResult,
                filteredOrders: _arrayResult,
                filteredSource: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('[Production.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                originalOrders: [],
                filteredOrders: [],
                filteredSource: [],
                loading: false
            }));
        }
    },

    searchCurrent: ({ searchValue = '', excludeList = [], includeList = [], exactList = [] }) => (dispatch, getState) => {
        console.log('[Production.redux] searchCurrent');
        console.log('searchValue', searchValue ? searchValue : 'searchValue was NULL')

        const finalIncludeList = subtractFields(includeList, excludeList, exactList);
        const finalExactList = exactList.filter(field => !excludeList.includes(field));

        dispatch(actions.setState({ searchLoading: true }));

        setTimeout(() => {
            const { filteredSource, sortOrder, sortField } = getState().warehouseProd;
            let searchedSource = [];

            if (filteredSource) {
                for (let bp of filteredSource) {
                    if (searchValue === '') {
                        searchedSource.push(bp);
                        continue;
                    }

                    const matchedInclude = matchesIncludeFields(bp, finalIncludeList, searchValue);
                    const matchedExact = matchesExactFields(bp, finalExactList, searchValue);

                    if (matchedInclude || matchedExact) {
                        searchedSource.push(bp);
                    }
                }
            } else {
                console.error('filteredSource falsey')
                // console.error(filteredSource)
                // console.error(typeof filteredSource)
            }
            dispatch(actions.setState({
                searchedSource: [...searchedSource],
                searchValue,
                hasFilterBeenApplied: true,
                hasOrder: true,
            }));

            dispatch(actions.sortCurrent({
                field: sortField,
                order: sortOrder
            }));

            dispatch(actions.setState({ searchLoading: false }));
        }, 1000); // 1 second delay
    },

    sortCurrent: ({ field, order }) => (dispatch, getState) => {
        // console.log('[Production.redux] sortCurrent ')
        // console.log(field)
        // console.log(order)
        let { searchedSource, columns } = getState().warehouseProd;

        const numberSortColumns = [
            ...dateColumns,
            'card_code',
        ];

        let newColumns = columns.map((col) => {
            if (col.dataIndex === field) {
                return { ...col, sortOrder: order }
            } else {
                return { ...col, sortOrder: false }
            }
        });

        let productionOrders = searchedSource; // THIS

        if (field !== false) {
            let type = 'string';
            if (numberSortColumns.indexOf(field) !== -1) {
                type = 'number';
            }
            productionOrders = searchedSource.sort(makeSorter(type, field));
        }

        if (order === 'ascend') {
            productionOrders = productionOrders.reverse();
        }

        dispatch(actions.setState({
            columns: newColumns,
            filteredOrders: [...productionOrders],
            sortOrder: order,
            sortField: field,
        }));
    },


    getProductionPRODetails: (existingRow) => async (dispatch, getState) => {
        console.log('[Production.redux.js] getProductionPRODetails()');
        const state = getState().warehouseProd;
        dispatch(actions.setState({ loading: true }));
        // console.log(state.currentEditRow);
        // console.log(state.currentEditRow.docEntry);
        // console.log(existingRow);

        try {
            // QUERY Warehouse.GetPROFinishedGood
            let result = await api.get(`/warehouse/production/pro-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docEntry: state.currentEditRow.docEntry,
                },
            });
            // console.log(result);
            // console.log(result.detailLines.recordset);

            let _detailLines = [...result.detailLines.recordset];

            // add existing record.finishedQty to the new query result
            let editLine = _detailLines.find(row => row.docEntry === existingRow.docEntry);
            editLine.finishedQty = existingRow.finishedQty;

            dispatch(actions.setState({ detailLines: _detailLines }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    submitToIssue: (rows, viewMode, searchTerm, popSuccessCB, popPartialCB, popFailureCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] submitToIssue()');
        // console.log('rows',rows);
        // console.log('viewMode', viewMode);

        const state = getState().warehouseProd;

        // use rows.origSO for so mode or docNum for pro mode
        // in pro mode they should all have the same docNum, but in so mode there will be multiple docNums and a shared origSO
        let _lastSODocNum = viewMode === 'so' ? rows[0].origSO : rows[0].docNum; // hardcoded
        //console.log('_lastSODocNum', _lastSODocNum);


        if (!rows || rows.length <= 0) {
            popFailureCB();
            return null;
        }

        // combine rows by base DocEntry so they can be on the same GoodsIssue
        function groupByDocEntry(array) {
            const groupedArrays = {};
            array.forEach(obj => {
                const _docEntry = obj.docEntry;
                if (!groupedArrays[_docEntry]) {
                    groupedArrays[_docEntry] = [];
                }
                groupedArrays[_docEntry].push(obj);
            });
            return Object.values(groupedArrays);
        }

        const groupedRows = groupByDocEntry(rows);
        console.log(groupedRows);

        dispatch(actions.setState({ loading: true, failedDocEntries: [], errors: [] }));
        try {

            let failedDocEntries = [];
            let _errors = [];

            let result = await api.put('/warehouse/write-goods-issue',
                {
                    rows,
                    groupedRows,
                    //Comments: currentEditRow.notes,
                });
            console.log(result);
            // console.log(result.success);
            // console.log(result.responses);
            // console.log(result.statuses);

            let ordersWithErrorFromSAP;

            let _failedResponses = result.responses.filter((rsp) => {
                //console.log(rsp);
                return !rsp.successful;
            });


            let _failedStatuses = result.statuses.filter((stat) => {
                // NOTE result.statuses has both the error message and the grouped docEntry
                //console.log(stat);
                return !stat.key;
            });

            if (_failedResponses.length > 0) {
                console.log('_failedResponses ');
                console.log(_failedResponses);
                //popFailureCB();
            }

            if (_failedStatuses.length > 0) {
                console.log('_failedStatuses ');
                console.log(_failedStatuses);
                _failedStatuses.forEach((failure) => {
                    //console.log(failure);
                    //console.log(failure.error);
                    failedDocEntries.push(failure.groupDocEntry);
                });

                let OGorders = state.originalOrders; // slight BUG where the table populates back to unfiltered, but then properly filters again after a moment

                // failureMap: groupDocEntry -> failure object
                const failureMap = new Map(
                    _failedStatuses.map(f => [Number(f.groupDocEntry), f])
                );
                //console.log('failureMap', failureMap)

                const { orders, errors } = OGorders.reduce((acc, ordr) => {
                    const failure = failureMap.get(Number(ordr.docEntry));

                    if (failure) {
                        // console.log('match error, add issueErrorMsg property');
                        //console.log(ordr);
                        // console.log(failure.error[0]);

                        // 1 ** dont need to pop a seperate error notification for backflush items since they didnt enter a quantity
                        if (ordr.IssueType !== ___.PRODUCTION_MANUAL) {
                            acc.errors.push(`# ${ordr.docNum} ${failure.error[0]}`);
                        } else {
                            console.log('skipping backflush item')
                        }

                        // 2 ** but do need to keep the rows with sibling errors shown on the table 
                        acc.orders.push({
                            ...ordr,
                            issueErrorMsg: failure.error[0]
                        });

                    } else {
                        acc.orders.push(ordr);
                    }
                    return acc;
                }, { orders: [], errors: [] });

                ordersWithErrorFromSAP = orders;
                _errors = errors;
            }

            // console.log('ordersWithErrorFromSAP', ordersWithErrorFromSAP);
            // console.log('_errors', _errors);
            //console.log('failedDocEntries');
            //console.log(failedDocEntries);

            if (result.success === 'success') {
                console.log('submitToIssue success');

                popSuccessCB(searchTerm);

                const qtyMap = new Map(
                    rows.map(r => [r.docKey, r.qtyToIssue])
                );

                const updatedOrders = state.originalOrders.map(order => {
                    const submittedQty = qtyMap.get(order.docKey);

                    if (!submittedQty) return order;

                    return {
                        ...order,
                        issuedQty: (order.issuedQty || 0) + submittedQty,
                        finishedQty: (order.finishedQty || 0) + order.issuedQty + submittedQty
                    };
                });

                dispatch(actions.setState({
                    lastSelectedDocNum: _lastSODocNum,
                    lastViewMode: viewMode,
                    loading: false,
                    failedDocEntries: [],
                    originalOrders: updatedOrders,
                    filteredOrders: updatedOrders,
                    filteredSource: updatedOrders,
                    errors: _errors
                }));
            } else if (result.success === 'partial') {
                console.log('submitToIssue partial');
                popPartialCB(searchTerm);

                // IMPORTANT issuing rows that return a partial success would leave the successful rows 
                // on-hand count as it was before it was accepted, since we are not fetching new rows
                // this code will adjust the quantities and stitch the results back into the table
                const qtyMap = rows.reduce((map, r) => {
                    const key = Number(r.docEntry);
                    map.set(key, (map.get(key) || 0) + (r.qtyToIssue || 0));
                    return map;
                }, new Map());

                const updatedOrders = ordersWithErrorFromSAP.map(order => {
                    const submittedQty = qtyMap.get(Number(order.docEntry)) || 0;

                    if (!failedDocEntries.includes(Number(order.docEntry)) && submittedQty > 0) {
                        return {
                            ...order,
                            issuedQty: (order.issuedQty || 0) + submittedQty,
                            onHandQty: (order.onHandQty || 0) - submittedQty,
                            finishedQty: (order.finishedQty || 0) + submittedQty
                        };
                    }

                    return order;
                });

                dispatch(actions.setState({
                    loading: false,
                    failedDocEntries: failedDocEntries,
                    originalOrders: updatedOrders, // yes this is on purpose, IMPORTANT redundancy for how search and filters work
                    filteredOrders: updatedOrders,
                    filteredSource: updatedOrders,
                    errors: _errors,
                }));

            } else {
                console.log('submitToIssue else');
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntries: failedDocEntries,
                    originalOrders: ordersWithErrorFromSAP, // yes this is on purpose, IMPORTANT redundancy for how search and filters work
                    filteredOrders: ordersWithErrorFromSAP,
                    filteredSource: ordersWithErrorFromSAP,
                    errors: _errors,
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            popFailureCB();
        }
    },

    writeProductionOrder: (currentEditRow, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writeProductionOrder()');

        console.log(currentEditRow);
        const state = getState().warehouseProd;
        let { lastSelectedDocNum, lastViewMode } = state;

        dispatch(actions.setState({ loading: true }));
        try {
            let result = await api.put('/warehouse/write-goods-receipt-pro',
                {
                    BaseDocEntry: currentEditRow.docEntry,
                    BaseDocType: 202, // OR currentEditRow.objType
                    Qty: currentEditRow.finishedQty, // NOTE this is different than the incoming qty
                    Comments: currentEditRow.notes,
                    // TODO_UNUSED submit unused components
                });
            console.log(result);
            //console.log(result.data);

            console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getProductionOrders(lastSelectedDocNum, lastViewMode));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },

    writeProductionOrderNotes: (currentEditRow, closeNotesModalCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writeProductionOrderNotes()');
        console.log(currentEditRow);
        const state = getState().warehouseProd;
        let { lastSelectedDocNum, lastViewMode } = state;

        dispatch(actions.setState({ loadingDetails: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            orderNotes: currentEditRow.orderNotes,
            internalNotes: currentEditRow.internalNotes,
        };

        try {
            let result = await api.put('/warehouse/write-so-notes',
                sendBody);

            if (result.success) {
                console.log('success');
                dispatch(actions.setState({ loadingDetails: false, currentEditRow: null }));
                closeNotesModalCB();
                dispatch(actions.getProductionOrders(lastSelectedDocNum, lastViewMode));
                // TODO or stitch new notes into the table?
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write notes');
            console.error(err);
            dispatch(actions.setState({ loadingDetails: false }));
        }
    },

    writeSalesOrderNotes: (currentEditRow) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writeSalesOrderNotes()');
        // similar to writeProductionOrderNotes but without closing a modal, clearing the edit object, or refreshing the whole table
        console.log(currentEditRow);

        const state = getState().warehouseProd;

        dispatch(actions.setState({ loading: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            orderNotes: currentEditRow.orderNotes,
            internalNotes: currentEditRow.internalNotes,
        };

        try {
            let result = await api.put('/warehouse/write-so-notes',
                sendBody);

            if (result.success) {
                console.log('success');

                // stitch the notes back into the current rows and detail rows
                const updatedOrders = state.filteredOrders.map(order => {
                    if (order.docEntry === currentEditRow.docEntry) {
                        return { ...order, ...currentEditRow };
                    }
                    return order;
                });
                dispatch(actions.setState({
                    filteredOrders: updatedOrders,
                    currentEditRow: currentEditRow,
                    loading: false
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write notes');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },


    // similar to writeSalesSendTo but from the perspective of the PRO header page
    // a few specifics required for good transitions to and from the PRO lines pages
    writeSalesSendToFromheader: (currentEditRow, sendToValue) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writeSalesSendToFromheader()');
        // console.log(currentEditRow);
        // console.log(sendToValue);

        const state = getState().warehouseProd;

        dispatch(actions.setState({ sendingTo: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            sendTo: sendToValue,
        };

        try {
            let result = await api.put('/warehouse/write-so-send-to',
                sendBody);

            if (result.success) {
                console.log('success');

                // stitch the rows new sendToLocation so the filter works without refresh
                const updatedOrders = state.PROheaders.map(order => {
                    if (order.docEntry === currentEditRow.docEntry) {
                        return { ...order, sendToLocation: sendToValue };
                    }
                    return order;
                });

                dispatch(actions.setState({
                    PROheaders: updatedOrders,
                    filteredHeaders: updatedOrders, // yes we need to update this too
                    sendingTo: false
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write Send To');
            console.error(err);
            dispatch(actions.setState({ sendingTo: false }));
        }
    },

    writeSalesSendTo: (currentEditRow, sendToValue) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writeSalesSendTo()');
        // console.log(currentEditRow);
        // console.log(sendToValue);

        const state = getState().warehouseProd;

        dispatch(actions.setState({ sendingTo: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            sendTo: sendToValue,
        };

        try {
            let result = await api.put('/warehouse/write-so-send-to',
                sendBody);

            if (result.success) {
                console.log('success');

                // stitch the rows new sendToLocation so the filter works without refresh
                const updatedOrders = state.filteredOrders.map(order => {
                    if (order.docEntry === currentEditRow.docEntry) {
                        return { ...order, sendToLocation: sendToValue };
                    }
                    return order;
                });

                // stitch the headers with new sendToLocation or using back button shows stale data
                const updatedHeaders = state.PROheaders.map(header => {
                    if (header.docEntry === currentEditRow.docEntry) {
                        return { ...header, sendToLocation: sendToValue };
                    }
                    return header;
                });

                dispatch(actions.setState({
                    filteredOrders: updatedOrders,
                    PROheaders: updatedHeaders,
                    currentEditRow: { ...currentEditRow, sendToLocation: sendToValue },
                    sendingTo: false
                }));
            }


        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write Send To');
            console.error(err);
            dispatch(actions.setState({ sendingTo: false }));
        }
    },

    submitToFinish: (rows, searchTerm, popSuccessCB, popFailureCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] submitToFinish()');
        console.log('rows', rows);

        const state = getState().warehouseProd;
        let { lastSelectedDocNum, lastViewMode } = state;

        let _errors = [];

        if (!rows || rows.length <= 0) {
            console.error('no rows selected');
            _errors.push('no rows selected - manually change the finished quantity and click Finish (Batch)');

            // keep an eye on this, it might be a terrible flow of events
            dispatch(actions.setState({
                errors: _errors,
            }));

            popFailureCB();
            return null;
        }
        //console.log(rows);

        dispatch(actions.setState({ loading: true, failedDocEntriesBatch: [], errors: [] }));
        try {

            let failedDocEntriesBatch = [];

            let result = await api.put('/warehouse/write-goods-receipt-batch',
                {
                    rows,
                });
            console.log(result);
            //console.log(result.data);
            //console.log(result.success);
            //console.log(result.responses);
            //console.log(result.statuses);

            let _failedResponses = result.responses.filter((rsp) => {
                //console.log(rsp);
                return !rsp.successful;
            });

            let _failedStatuses = result.statuses.filter((stat) => {
                //console.log(stat);
                return !stat.key;
            });

            if (_failedResponses.length > 0) {
                console.log('_failedResponses ');
                console.log(_failedResponses);
            }

            if (_failedStatuses.length > 0) {
                console.log('_failedStatuses ');
                console.log(_failedStatuses);
                _failedStatuses.forEach((failure) => {
                    //console.log(failure);
                    //console.log(failure.error);
                    failedDocEntriesBatch.push(failure.groupDocEntry);
                    _errors.push(failure.error[0]); // TODO_HARDCODE_ERROR_INDEX
                });
            }

            console.log('failedDocEntriesBatch');
            console.log(failedDocEntriesBatch);

            if (result.success === 'partial') {
                console.log('submitToFinish partial success');
                popSuccessCB(searchTerm);
                // TODO what can we do with erroneous rows
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntriesBatch: failedDocEntriesBatch,
                    errors: _errors,
                }));

                // for this feature we are not concerned with stitching and adding errors to the rows, so just get new data
                dispatch(actions.getProductionOrders(lastSelectedDocNum, lastViewMode));

            } else if (result.success && result.success === 'success') {
                console.log('submitToFinish success');
                popSuccessCB(searchTerm);
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntriesBatch: failedDocEntriesBatch,
                    errors: _errors
                }));
                dispatch(actions.getProductionOrders(lastSelectedDocNum, lastViewMode));

            } else {
                dispatch(actions.setState({
                    loading: false,
                    failedDocEntriesBatch: failedDocEntriesBatch,
                    errors: _errors,
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            popFailureCB();
        }
    },

    writePurchaseOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Production.redux.js] writePurchaseOrder()');
        //console.log(currentEditRow);
        //console.log(editDetailsLines);

        const state = getState().warehouseProd;
        let { lastSelectedDocNum, lastViewMode } = state;

        dispatch(actions.setState({ loading: true }));

        let _filtered = editDetailsLines.filter((r) => (r.orderQty && r.orderQty > 0));
        //console.log(_filtered);

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
            submitRows: _filtered,
        };

        // TODO_BLANK_NOTES need to prevent writing comments if they are blank, except when they would be intentionally blank
        if (currentEditRow.notes && currentEditRow.notes !== '') {
            sendBody.Comments = currentEditRow.notes;
        }

        try {
            let result = await api.put('/warehouse/write-grpo',
                sendBody);
            console.log(result);
            console.log(result.data);

            //console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getProductionOrders(lastSelectedDocNum, lastViewMode));
                //dispatch(actions.setState({ purchaseOrders: result.purchaseOrders.recordset }));
            }

            //console.log(result.errorMsg); // errorMsg: "One of the base documents has already been closed"

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },
    get_warehouse_options: () => async (dispatch) => {
        console.log('[Production.redux.js] get_warehouse_options');
        // TODO we could probably consolidate the three routes/queries into one, but we didnt know where the default warehouse was supposed to come from at the time, so we made separate routes/queries for each.
        dispatch(actions.setState({ loading: true }));

        api.get('/warehouse/get-warehouse-options-po/').then(res => {
            let warehouseOptions = res.options;

            dispatch(actions.setState({ warehouseOptions }));
            dispatch(actions.setState({ loading: false }));
        }).catch(err => {
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        });
    },
};
